module.exports = __webpack_public_path__ + "static/img/huaishu.4c96b83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Btn/huaishu.png
// module id = e+mK
// module chunks = 0